/** Single application-owned entry point for map rendering; it never contains an API key. */
export const MAP_PROVIDER_CONFIG = {
  // Use the same keyless OSM-derived style in every environment until the
  // self-hosted production tile catalog is provisioned and monitored.
  styleUrl: 'https://tiles.openfreemap.org/styles/dark',
  attribution: '© OpenStreetMap'
} as const;
